import { DialCode } from '@previo/codebooks'
import { type InternationalPhoneNumber } from '../../types/InternationalPhoneNumber'

const groupNumber = (number: string): string => {
  const compactNumber = number.replace(/\s/g, '')

  return compactNumber.match(/.{1,3}/g)?.join(' ') ?? compactNumber
}

export const getFullPhoneNumber = (phoneNumber?: InternationalPhoneNumber | null): string => {
  if (!phoneNumber?.number) {
    return ''
  }

  const number = groupNumber(String(phoneNumber.number))

  try {
    const dialCode = DialCode.getById(phoneNumber.dialCodeId)

    return `${dialCode.dialCode} ${number}`
  } catch {
    return number
  }
}

export const getPhoneNumberTelHref = (phoneNumber?: InternationalPhoneNumber | null): string => {
  const fullPhoneNumber = getFullPhoneNumber(phoneNumber)

  if (!fullPhoneNumber) {
    return ''
  }

  return `tel:${fullPhoneNumber.replace(/\s/g, '')}`
}
